import { render, staticRenderFns } from "./JghMonograph.vue?vue&type=template&id=fdddea38&scoped=true"
import script from "./JghMonograph.vue?vue&type=script&lang=js"
export * from "./JghMonograph.vue?vue&type=script&lang=js"
import style0 from "./JghMonograph.vue?vue&type=style&index=0&id=fdddea38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdddea38",
  null
  
)

export default component.exports